/**
 * Cliente de la API del cobro por QR (/api/qr).
 *
 * El backoffice en general no manda el token; estas pantallas sí, porque la API tiene
 * que saber si quien consulta es admin o promotor (un promotor solo ve sus ventas).
 */
import axios from "axios";

const apiQr = axios.create({ baseURL: `${process.env.VUE_APP_API_URL}/qr` });

apiQr.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

/** Mensaje legible de un error de axios */
export const mensajeError = (error, porDefecto = "Ocurrió un error") =>
  error?.response?.data?.message || error?.response?.data?.error || porDefecto;

/** Descarga un archivo de la API (Excel, QR) con el token */
export const descargar = async (url, nombre, params = {}) => {
  const { data } = await apiQr.get(url, { params, responseType: "blob" });
  const enlace = document.createElement("a");
  enlace.href = URL.createObjectURL(data);
  enlace.download = nombre;
  document.body.appendChild(enlace);
  enlace.click();
  enlace.remove();
  setTimeout(() => URL.revokeObjectURL(enlace.href), 1000);
};

/** URL local (blob) de una imagen de la API, para mostrarla en un <img> */
export const imagenBlob = async (url, params = {}) => {
  const { data } = await apiQr.get(url, { params, responseType: "blob" });
  return URL.createObjectURL(data);
};

export default apiQr;
